import React from "react";
import { Button, Modal } from "react-bootstrap";
import "../../styles/components/Admin/AdminPopUp.scss";
import { Trans } from "react-i18next";

interface AdminPopUpType {
  show: boolean;
  handelClose: () => void;
  handleOnSubmit: () => void;
  title_key: string;
  body: JSX.Element;
  primaryButtonTitle_key: string;
  secondaryButtonTitle_key: string;
}

const AdminPopUp = ({
  show,
  handelClose,
  handleOnSubmit,
  title_key,
  body,
  primaryButtonTitle_key,
  secondaryButtonTitle_key,
}: AdminPopUpType) => {
  return (
    <>
      <Modal
        show={show}
        onHide={() => {
          handelClose();
        }}
        id="adminPopup"
        centered={true}
      >
        <Modal.Header closeButton className="userModelHeader">
          <Modal.Title data-testid="popupTestTitle">
            <Trans i18nKey={title_key?.toLowerCase()} />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>{body}</Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            data-testid="popupSecondaryText"
            onClick={() => {
              handelClose();
            }}
          >
            <Trans i18nKey={secondaryButtonTitle_key?.toLowerCase()} />
          </Button>
          <Button
            data-testid="popupPrimaryText"
            variant="primary"
            onClick={() => {
              handleOnSubmit();
            }}
          >
            <span className="text-capitalize">
              <Trans i18nKey={primaryButtonTitle_key?.toLowerCase()} />
            </span>
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AdminPopUp;
